var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"terms-box"},[_c('ywhz-title-style-card',{attrs:{"title":_vm.$t('menu.menu4-4'),"subtitle":"TRANSPORT TERMS"}}),_c('div',{staticClass:"layout-width layout-r"},[_c('agreement',{attrs:{"show":"条款与细则"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }